/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import applicationFormStyle from "./applicationFormStyle";
import { leftIcon } from "@/src/theme/commonStyle";

const wizardStyle = {
  ...applicationFormStyle,
  padPaper: {
    margin: "1rem 0",
    textAlign: "center",
    border: "1px solid #fff",
    padding: "1rem",
    cursor: "pointer",
  },
  labelIcon: {
    "& svg": { fontSize: "3rem" },
  },
  labelText: {
    padding: "1rem",
  },
  wizardForm: {
    maxWidth: "550px",
    margin: "0 auto",
  },
  paper: {
    padding: "1rem",
  },
  formHelperText: {
    fontSize: "1rem",
    textAlign: "center",
  },
  question: {
    textAlign: "center",
    fontSize: "1.25rem",
    lineHeight: 1.5,
  },
  signatureImage: {
    maxWidth: "100%",
  },
  signatureCaption: {
    textAlign: "center",
  },
  checkbox: {
    marginTop: "1rem",
  },
  warningText: {
    color: "error.main",
  },
  leftIcon,
  hintHeader: {
    paddingTop: "1rem",
  },
  icon: { marginRight: "1.5rem" },
};

export default wizardStyle;
